import { render, staticRenderFns } from "./VirtualMenu.vue?vue&type=template&id=8a84625c&scoped=true"
import script from "./VirtualMenu.vue?vue&type=script&lang=js"
export * from "./VirtualMenu.vue?vue&type=script&lang=js"
import style0 from "./VirtualMenu.vue?vue&type=style&index=0&id=8a84625c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a84625c",
  null
  
)

export default component.exports